<template>
    <div>
        <!-- User Interface controls -->
        <b-row>
          <b-col md="2" class="my-1">
            <b-button-group>
              <b-button @click="upcomingSchedule()" class="btn btn-warning btn-sm">
                <span class="icon icon-calendar"> Upcoming</span>
              </b-button>
              <b-button @click="fullSchedule()" class="btn btn-primary btn-sm">
              <span class="icon icon-calendar"> Full</span>
              </b-button>
            </b-button-group>
          </b-col>
            <b-col md="5" class="my-1">
                <b-form-group label-cols="2" class="mb-0">
                    <b-input-group>
                        <b-form-input v-model="filter" placeholder="Type to Search" />
                        <b-input-group-append>
                            <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col md="5" class="my-1">
                <b-form-group label-cols-md="4" label="Per page" class="mb-0">
                    <b-form-select :options="pageOptions" v-model="perPage" />
                </b-form-group>
            </b-col>
        </b-row>
        <!-- Main table element -->
            <b-table show-empty empty-text="The schedule will appear here after entering shifts"       striped responsive stacked="md" caption-top
                 :items="items" 
                 :fields="fields" 
                  :filter="filter"
                  :current-page="currentPage" 
                  :per-page="perPage" 
                  :sort-by.sync="sortBy"
                 @filtered="onFiltered">
            <template v-slot:cell(date)="row">
              {{ moment(row.item.date).format('MMM-DD-YYYY') }}
            </template>
            <template v-slot:cell(evaluation_sent)="row">
              <span v-if="row.item.evaluation_sent == true" class="text-success">Yes</span>
              <span v-else>No</span>
            </template>
            <template v-slot:cell(actions)="row" class="text-nowrap">
                <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                <b-button-group>
                    <b-button v-if="role == 'instructor' || role == 'admin'" @click="editShift(row.item.id)" class="btn btn-warning btn-sm">
                        <span class="icon icon-pencil"></span>
                    </b-button>
                    <b-button v-if="role == 'instructor' || role == 'admin'" @click="info(row.item.date, row.item.id, $event.target)" class="btn btn-danger">
                    <span class="icon icon-trash"></span>
                    </b-button>
                </b-button-group>
            </template>
            <template v-slot:table-caption>DE = Daily Evaluation</template>
        </b-table>
        <!-- Info modal -->
        <b-modal ok-title="Yes Delete" cancel-title="Cancel" ok-variant="danger" cancel-variant="primary" id="modalInfo" @hide="resetModal" @ok="deleteShift" :title="modalInfo.title">
          <p>{{ modalInfo.content }}</p>
        </b-modal>
        <b-row>
          <b-col md="6" class="my-1">
            <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
          </b-col>
        </b-row>
 
    </div>
</template>

<script>
const items = [];
var moment = require('moment');
export default {
  props: ['schedule', 'user_role', 'students', 'rotations'],
  data() {
    return {
      moment: moment,
      items: this.schedule,
      role: this.user_role,
      fields: [
        { key: "date", label: "Date" },
        { key: "user.name", label: "Student" },
        { key: "rotation", label: "Rotation"},
        { key: "hospital.hospital", label: "Location"},
        { key: "shift", label: "Shift"},
        { key: "shift_length", label: "Hours"},
        { key: "evaluation_sent", label: "DE Sent"},
        { key: "actions", label: "Action"}
      ],
      filter: null,
      currentPage: 1,
      perPage: 25,
      totalRows: this.schedule.length,
      pageOptions: [25, 50, 100],
      sortBy: null,
      modalInfo: { title: '', content: '', id: '' }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(f => f.sortable).map(f => {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    editShift(id) {
        if(this.user_role == 'admin') {
          window.location.href = "/admin/schedule/edit/" + id;
        }
        else {
          window.location.href = "/instructor/schedule/edit/" + id;
        }
         
    },
    info(date, id, button) {
        this.modalInfo.title = `Are you sure you want to delete?`
        this.modalInfo.content = "This shift on " + date
        this.modalInfo.id = id
        this.$root.$emit('bv::show::modal', 'modalInfo', button)
      },
    resetModal() {
        this.modalInfo.title = ''
        this.modalInfo.content = ''
        this.modalInfo.id = ''
    },
    deleteShift(id) {
        this.modalInfo.title = ''
        this.modalInfo.content = ''
        axios.get('/instructor/schedule/delete/' + this.modalInfo.id)
            .then(response => this.items = response.data)
            .catch(function (error) {
                // handle error
                console.log(error);
            });
            swal({
          title: "Shift Deleted!",
          icon: "success"
        });
    },
    fullSchedule() {
        axios.get('/instructor/schedule/full')
            .then(response => this.items = response.data)
            .catch(function (error) {
                // handle error
                console.log(error);
            });
    },
    upcomingSchedule() {
        axios.get('/instructor/schedule/future')
            .then(response => this.items = response.data)
            .catch(function (error) {
                // handle error
                console.log(error);
            });
    },
  },
};
</script>

<!-- table-complete-1.vue -->